export default __webpack_public_path__ + "static/1488-33ad90f9d1f150355cd78ce888397e60.gif";